// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_kl-0";